import React from 'react';
import { useAuthStore } from '@/stores/auth.store';
import { isInstitutionMenuEnabled } from '@/lib/institution-menu-flags';
import { InstitutionFeatureBlocked } from './InstitutionFeatureBlocked';

type Props = {
  flagKey: string;
  children: React.ReactNode;
};

/**
 * Bloque une route si le menu correspondant est désactivé pour l’institution de l’utilisateur.
 * Sans institution : pas de restriction (comportement inchangé).
 */
export function InstitutionFeatureGate({ flagKey, children }: Props) {
  const user = useAuthStore((s) => s.user);
  const flags = user?.institutionDashboardMenuFlags;

  if (!user?.institutionId) {
    return <>{children}</>;
  }

  if (!isInstitutionMenuEnabled(flags, flagKey)) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center p-6">
        <InstitutionFeatureBlocked />
      </div>
    );
  }

  return <>{children}</>;
}
